export default __webpack_public_path__ + "static/media/products-to-cart-or-basket.eb053015.svg";